import fetchRequest from '../util/fetch'
import errUtil from '../util/error'

const query = `mutation AgendaTaskUpdate (
  $workspace: ID!
  $id: ID!
  $task: ID!
  $done: Boolean!
) {
  shiftUpdateAgendaTaskUpdate (
    workspace: $workspace
    id: $id
    task: $task
    done: $done
  ) {
    id
  }
}`

async function requestAgendaTaskUpdate (variables, token) {
  const response = await fetchRequest({ query, variables, token })
  if (!response) return errUtil.noResponse()

  const { errors, data } = response
  if (errors) {
    return errUtil.apiError('agenda-task-update', errors)
  }
  return data.requestAgendaTaskUpdate
}

export default requestAgendaTaskUpdate
